import { normalizeCompanyKey } from './normalizeCompanyKey';
export const validateRecipientClientBusiness = (param)=>{
    let { primary, recipient } = param;
    if (primary == null) {
        return {
            valid: true
        };
    }
    const primaryCustomerId = primary.customerId();
    const recipientCustomerId = recipient.customerId();
    if (primaryCustomerId != null && recipientCustomerId != null) {
        return primaryCustomerId === recipientCustomerId ? {
            valid: true
        } : {
            valid: false,
            reason: 'differentClientBusiness'
        };
    }
    if (recipientCustomerId != null && primaryCustomerId == null) {
        return {
            valid: false,
            reason: 'differentClientBusiness'
        };
    }
    return normalizeCompanyKey(primary.companyName()) === normalizeCompanyKey(recipient.companyName()) ? {
        valid: true
    } : {
        valid: false,
        reason: 'differentClientBusiness'
    };
};
